import { useEffect } from 'react';

export const ANALYSIS_COMPLETE_EVENT = 'endchess:analysis-complete';

export type AnalysisCompleteDetail = {
  gameId: string;
};

export function notifyAnalysisComplete(detail: AnalysisCompleteDetail): void {
  window.dispatchEvent(
    new CustomEvent<AnalysisCompleteDetail>(ANALYSIS_COMPLETE_EVENT, {
      detail,
    }),
  );
}

export function useAnalysisComplete(
  handler: (detail: AnalysisCompleteDetail) => void,
): void {
  useEffect(() => {
    const listener = (event: Event) => {
      handler((event as CustomEvent<AnalysisCompleteDetail>).detail);
    };

    window.addEventListener(ANALYSIS_COMPLETE_EVENT, listener);
    return () => window.removeEventListener(ANALYSIS_COMPLETE_EVENT, listener);
  }, [handler]);
}
